import React from 'react';
import { Button, Modal, CloseButton } from 'react-bootstrap';
import styles from '../../CardDetails/CardDetails.module.css';
import QuestionnaireDetails from '../../CardDetails/QuestionnaireDetails';

function QuestionnaireGraphScore({ isModalVisible, handleCloseModal, modalData }) {
    const questions = modalData?.questions ?? [];
    const answers = modalData?.answers ?? [];
    const missed = modalData?.missedStatus;
    
    const convertDate = (dateStr) => {
        if (dateStr) {
            const completedDate = new Date(dateStr);
            const month = completedDate.toLocaleString('en-US', { month: 'long' });
            const day = completedDate.getDate();
            const year = completedDate.getFullYear();
            return `${month} ${day}, ${year}`;
        } else {
            return ""
        }
    };

    return (
        <Modal
            show={isModalVisible}
            onHide={handleCloseModal}
            centered={true}
            backdrop="static"
        >
            <Modal.Header style={{ borderBottom: "none", display:"flex", flexDirection:"column" }}>
                <div className="d-flex justify-content-between align-items-center" style={{width:"100%"}}>
                    <div className={styles.QScoreHeaderItems}>
                        <div className={styles.QScoreTitle}>{modalData?.name}</div>
                    </div>
                    <div className={styles.QScoreBadge} style={{background: missed ? "#9F1919" : "#1F5C29"}}>Completed</div>
                </div>
                <div className={styles.QScoreSubHeader}>{convertDate(modalData?.completedDate)}</div>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.DetailsContainer} style={{height:"90%", overflowY: "auto"}}>
                   <QuestionnaireDetails questionnaire={modalData} />
                </div>
            </Modal.Body>
            <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', borderTop: "0.5px solid #B9B9B9" }}>
                <Button className={styles.CloseModalButton} onClick={handleCloseModal}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default QuestionnaireGraphScore;
